import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StammkundeService } from '../../../Services/stammkunde.service';
import { WarehouseRef } from '../../../Models/stammkunde.model';

export interface LagerLinkData {
  customerId: number;
  linked: WarehouseRef[];
}

/** Popup zum Verknüpfen eines Lagers mit dem Stammkunden. */
@Component({
  selector: 'app-lager-link',
  templateUrl: './lager-link.component.html',
  styleUrls: ['./lager-link.component.css', '../stammkunden-theme.css']
})
export class LagerLinkComponent implements OnInit {
  available: WarehouseRef[] = [];
  selectedId: number | null = null;
  loading = true;
  saving = false;

  constructor(
    public dialogRef: MatDialogRef<LagerLinkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LagerLinkData,
    private stammkundeService: StammkundeService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    const linkedIds = new Set((this.data.linked ?? []).map(w => w.id));
    this.stammkundeService.getMyWarehouses().subscribe({
      next: warehouses => {
        this.available = (warehouses ?? []).filter(w => !linkedIds.has(w.id));
        this.loading = false;
      },
      error: () => {
        this.available = [];
        this.loading = false;
        // Ohne Hinweis sähe der Fehler wie "kein Lager verfügbar" aus.
        this.snackBar.open('Fehler beim Laden der Lager.', 'OK', { duration: 5000 });
      }
    });
  }

  select(warehouse: WarehouseRef): void {
    this.selectedId = this.selectedId === warehouse.id ? null : warehouse.id;
  }

  save(): void {
    if (this.selectedId == null) return;
    this.saving = true;
    this.stammkundeService.linkWarehouse(this.data.customerId, this.selectedId).subscribe({
      next: () => {
        this.saving = false;
        this.dialogRef.close(true);
      },
      error: err => {
        this.saving = false;
        const message = err?.error?.message || 'Fehler beim Verknüpfen des Lagers.';
        this.snackBar.open(message, 'OK', { duration: 5000 });
      }
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
